import { TypographyWithInfoIcon } from "@components";
import { Box, styled, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const MenuItemContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
  cursor: "pointer",
  borderRadius: "6px",
  transition: "background-color 0.2s ease-in-out",
  backgroundColor: active
    ? theme.palette.background.neutralDark
    : "transparent",

  "&:hover": {
    backgroundColor: theme.palette.background.neutralDark,
  },
}));

export const SettingsMenuItem = ({
  title,
  to,
  icon,
  active,
  secondary,
  hasNoAccounts,
  onClick,
}: {
  title: string;
  icon: React.ReactNode;
  to?: string;
  active: boolean;
  secondary?: boolean;
  hasNoAccounts?: boolean;
  onClick?: () => void;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const handleClick = () => {
    onClick?.();
    if (!to) return;
    try {
      const url = new URL(to);
      window.location.assign(url);
    } catch (e) {
      navigate(to);
    }
  };

  return (
    <MenuItemContainer
      onClick={handleClick}
      active={active}
      color={secondary ? theme.palette.icon.secondary : undefined}
    >
      <Box
        display="flex"
        alignItems="center"
        color={
          active ? theme.palette.text.primary : theme.palette.icon.secondary
        }
      >
        {icon}
      </Box>
      <TypographyWithInfoIcon
        tooltipText={
          hasNoAccounts
            ? t("settings.sidebar.bankConnections.noAccountsTooltip")
            : undefined
        }
        variant="body3"
        noWrap
      >
        {title}
      </TypographyWithInfoIcon>
    </MenuItemContainer>
  );
};
